import * as React from "react";
const SvgFlux = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 32,
    height: 32,
    viewBox: "2 2 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 30, height: 30, rx: 15, fill: "black" }),
  /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 30, height: 30, rx: 15, stroke: "white", strokeWidth: 2 }),
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_12443_53086)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.6 24.4H10.12V21.824L9 20.48L10.8667 18.8L9 17.12L10.8667 15.44L9 13.76L10.9413 12.024L10.12 11.184V7.59998H22.44V11.52H14.6V13.76H21.88V17.68H14.6V24.4ZM11.24 23.28H13.48V16.56H20.76V14.88H13.48V10.4H21.32V8.71998H11.24V10.736L12.6587 12.1546L10.68 13.76L12.7333 15.44L10.68 17.12L12.7333 18.8L10.68 20.48L11.24 21.376V23.28Z",
      fill: "#1DFDC0"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_12443_53086" }, /* @__PURE__ */ React.createElement("rect", { width: 13.44, height: 16.8, fill: "white", transform: "translate(9 7.59998)" })))
);
export default SvgFlux;
